import { get } from 'lodash';
import initialState from './initialState';
import * as types from './actionTypes';
// eslint-disable-next-line import/no-cycle
import {
  EnvironmentsState,
  EnvironmentsActions,
  CreateEnvSuccess,
  CreateEnvError,
  FetchEnvListSuccess,
  FetchEnvListError,
  DeleteEnvError,
  EditEnvError,
} from './types';

const handleEnvironmentsRequest = (state: EnvironmentsState) => ({
  ...state,
  isLoading: true,
  error: null,
});

const handleCreateEnvironmentSuccess = (
  state: EnvironmentsState,
  action: CreateEnvSuccess,
) => ({
  ...state,
  list: [...state.list, action.payload],
  isLoading: false,
  error: null,
});

const handleCreateEnvironmentError = (
  state: EnvironmentsState,
  action: CreateEnvError,
) => ({
  ...state,
  isLoading: false,
  error: action.error,
});

const handleFetchEnvironmentsListSuccess = (
  state: EnvironmentsState,
  action: FetchEnvListSuccess,
) => ({
  ...state,
  list: action.payload,
  isLoading: false,
  error: null,
});

const handleFetchEnvironmentsListError = (
  state: EnvironmentsState,
  action: FetchEnvListError,
) => ({
  ...state,
  isLoading: false,
  error: action.error,
});

const handleDeleteEnvironmentError = (
  state: EnvironmentsState,
  action: DeleteEnvError,
) => ({
  ...state,
  isLoading: false,
  error: get(action, 'error.detail', 'Something went wrong'),
});

const handleEditEnvironmentError = (
  state: EnvironmentsState,
  action: EditEnvError,
) => ({
  ...state,
  isLoading: false,
  error: get(action, 'error.detail', 'Something went wrong'),
});

export default (
  state: EnvironmentsState = initialState,
  action: EnvironmentsActions,
): EnvironmentsState => {
  if (!action) {
    return state;
  }
  switch (action.type) {
    case types.ENVIRONMENTS_REQUEST:
      return handleEnvironmentsRequest(state);
    case types.CREATE_ENVIRONMENT_SUCCESS:
      return handleCreateEnvironmentSuccess(state, action);
    case types.CREATE_ENVIRONMENT_ERROR:
      return handleCreateEnvironmentError(state, action);
    case types.FETCH_ENVIRONMENTS_LIST_SUCCESS:
      return handleFetchEnvironmentsListSuccess(state, action);
    case types.FETCH_ENVIRONMENTS_LIST_ERROR:
      return handleFetchEnvironmentsListError(state, action);
    case types.DELETE_ENVIRONMENT_ERROR:
      return handleDeleteEnvironmentError(state, action);
    case types.EDIT_ENVIRONMENT_ERROR:
      return handleEditEnvironmentError(state, action);
    default:
      return state;
  }
};
